@if(showResultList === true && listToShow.length !== 0){
<div
    class="closing"
    (click)="toggleResultView()"
    *ngIf="showResultList === true"
></div>
<div class="wrapper">
    <div
        *ngFor="let re of listToShow; let index = index"
        class="w100 wrapperlist col"
    >
        <!-- <span class="stepname"
            >STEP - {{ index + 1 }} {{ re.file ? re.name : "" }}</span
        > -->
        @if(re.type !== "briefing-material"){
        <div class="row align-center w100 space-between resultitem">
            <div
                class="row align-center gap-8 pointer"
                (click)="downloadFile(re)"
            >
                <rr-icon name="file" color="nutral" class="roundicon"></rr-icon>
                @if(re.file){
                <div class="col" *ngIf="re.file">
                    <span class="filename">{{ re.file.fileName }}</span>
                    <span class="filesize"
                        >{{ re.file.fileSize | calcFileSizeInKb }} -
                        {{ re.file.dateCreated | localTimeDate }}</span
                    >
                </div>
                }@else if(re.stepId === 'landingPage') {
                <div class="col">
                    <span class="filename">{{ re.name }}</span>
                    <span class="filesize">open Preview</span>
                </div>
                }@else {
                <div class="col">
                    <span class="filename">{{ re.name }}</span>
                    <span class="filesize"
                        >Click to generate & download file</span
                    >
                </div>
                }
            </div>
            <rr-icon
                name="trash"
                color="nutral"
                class="pointer delbtn"
                *ngIf="re.file && re.file.userId == userId"
                (click)="deleteFile(re)"
            ></rr-icon>
        </div>
        }
    </div>
</div>
}
<rr-btn
    type="Secondary"
    size="Small"
    (click)="toggleResultView()"
    [counter]="counter"
    [disabled]="listToShow!.length > 0 ? false : true"
>
    Show Results
</rr-btn>
